export function pad2(n: number): string {
  return n < 10 ? `0${n}` : String(n);
}
export function mmss(s: number): string {
  s = Math.max(0, Math.round(s));
  return `${pad2(Math.floor(s / 60))}:${pad2(s % 60)}`;
}
/** mm:ss until an hour, then h:mm:ss (the HPress grid wraps at 60:00; AirPost does not). */
export function rt(s: number): string {
  s = Math.max(0, Math.round(s));
  if (s < 3600) return mmss(s);
  return `${Math.floor(s / 3600)}:${pad2(Math.floor((s % 3600) / 60))}:${pad2(s % 60)}`;
}
export function hhmmss(s: number): string {
  s = Math.max(0, Math.round(s));
  return `${pad2(Math.floor(s / 3600))}:${pad2(Math.floor((s % 3600) / 60))}:${pad2(s % 60)}`;
}
export function parseMmSs(text: string): number | null {
  const parts = text.trim().split(':');
  if (parts.some((p) => !/^\d{1,3}$/.test(p)) || parts.length === 0 || parts.length > 3) return null;
  const n = parts.map(Number);
  return n.length === 1 ? n[0]! : n.length === 2 ? n[0]! * 60 + n[1]! : n[0]! * 3600 + n[1]! * 60 + n[2]!;
}
export function todayIso(): string {
  // station date: the browser clock of the newsroom PC is station time
  const d = new Date();
  return `${d.getFullYear()}-${pad2(d.getMonth() + 1)}-${pad2(d.getDate())}`;
}
export function fmtDateInput(iso: string): string {
  const [y, m, d] = iso.split('-');
  return `${d}/${m}/${y}`;
}
/** A bulletin date (YYYY-MM-DD) with its weekday, in the interface's language: "Δευτέρα 26/10/2026". */
export function fmtDayDate(iso: string, locale: 'el' | 'en' = 'el'): string {
  const [y, m, d] = iso.split('-').map(Number);
  if (!y || !m || !d) return iso;
  // noon UTC: the same calendar day in every time zone
  const weekday = new Date(Date.UTC(y, m - 1, d, 12)).toLocaleDateString(locale === 'el' ? 'el-GR' : 'en-GB', { weekday: 'long', timeZone: 'UTC' });
  return `${weekday.charAt(0).toUpperCase()}${weekday.slice(1)} ${fmtDateInput(iso)}`;
}
export function fmtDateTime(iso: string): string {
  const d = new Date(iso);
  return `${pad2(d.getDate())}/${pad2(d.getMonth() + 1)}/${d.getFullYear()} ${pad2(d.getHours())}:${pad2(d.getMinutes())}:${pad2(d.getSeconds())}`;
}
export function classes(...xs: Array<string | false | null | undefined>): string {
  return xs.filter(Boolean).join(' ');
}
